import { DetailsList, Panel, PanelType, Spinner, SelectionMode, MessageBar, MessageBarType, IColumn, PrimaryButton } from "office-ui-fabric-react"
import { useEffect, useState } from "react";
import { Route, RouteComponentProps, useHistory } from "react-router";
import { loadRoomsByApprover } from "../../../api/rooms";
import { RoomFormPanel } from "../forms/RoomFormPanel";
import { IRoom } from "../../../types/SiteLocation.types"

export interface IUpdateRoomDetailsProps {
    onDismiss: () => void;
}

export const UpdateRoomDetails = (props: IUpdateRoomDetailsProps) => {
    const { onDismiss } = props;
    const history = useHistory();

    const [ rooms, setRooms ] = useState<Partial<IRoom>[]>();
    const [ error, setError ] = useState<string>();
    const [ loading, setLoading ] = useState(false);

    const _loadRooms = async () => {
        setLoading(true);
        const locationsResponse = await loadRoomsByApprover();
        if (locationsResponse.ok) {
            setRooms(await locationsResponse.json());
        } else {
            setError("Unable to load rooms: " + locationsResponse.statusText);
        }
        setLoading(false);
    };

    

    useEffect(() => {
        _loadRooms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Panel 
            headerText="Update Room Details" 
            isOpen={true} 
            onDismiss={onDismiss}
            type={PanelType.medium} 
        >
            { error !== undefined && (
                <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>
            )}
            <p><strong>Update room details</strong></p>
            <p>
                Manage room details - like Capacity, Equipment, Notes/Messages
            </p>
            { loading === true && (
                <Spinner />
            )}
            { loading === false && rooms !== undefined && rooms.length > 0 && (
                <DetailsList
                    items={rooms.sort((a,b) => (a?.Name || "") < (b?.Name || "") ? -1 : 1)}
                    columns={[
                        {
                            key: "name",
                            fieldName: "Name",
                            name: "Name",
                            minWidth: 40
                        },
                        {
                            key: "site",
                            fieldName: "SiteName",
                            name: "Site / Location",
                            minWidth: 40,
                            onRender: (item: IRoom, column, index) => {
                                if (!(Boolean(item.SiteName) && Boolean(item.LocationName))) return null;
                                return (
                                    <>
                                        { item.SiteName }<br/>
                                        { item.LocationName }
                                    </>
                                );
                            }
                        },
                        {
                            key: "edit",
                            fieldName: "Id",
                            name: "Edit",
                            minWidth: 80,
                            onRender: (item: IRoom) => {
                                return (
                                    <PrimaryButton iconProps={{iconName: "Edit"}} onClick={() => {
                                        history.push(`/menu/settings/updateroomdetails/${item.Id}/edit`);
                                    }} />
                                )
                            }
                        }
                    ]}
                    selectionMode={SelectionMode.none}
                />
            )}
            <Route path="/menu/settings/updateroomdetails/:roomId/edit" exact={true} component={(route: RouteComponentProps<{roomId?: string|undefined}>) => {
                if (!Number.isNaN(Number(route.match.params.roomId))) {
                    const roomId = parseInt(route.match.params.roomId as string, 10);
                    const room = rooms?.find((r) => r.Id === roomId);
                    if (room) {
                        return <RoomFormPanel asRoomApprover={true} room={room} onDismiss={(reloadLocations) => {
                            history.goBack();
                            if (reloadLocations) {
                                _loadRooms();
                            }
                        }} />;
                    } else {
                        return null;
                    }
                }
                return null;
            }} />
        </Panel>
    )
}